import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const ssn: AnswerPathTreeNode = { path: 'ssn', nodeId: NodeIds.insuredSSN };
